export class PreparationHDModel{
  docNumber ='';
  docDate ='2022-01-01';
  exDate ='2022-01-01';
  docCode  ='';
  docPhCode  ='';
  paIntCode  ='';
  patientFName ='';
  paBirthDate ='2022-01-01';
  prepAge = 0;
  paGender ='';
  cancerType ='';

  diganosisDate ='2022-01-01';
  diganosis  ='';
  pathology  ='';
  patientStatus  ='';
  cBCDate ='2022-01-01';
  paProtocol = '';
  paSycle = 0;
  paDays = 0;
  paPuls ='';
  paBP ='';

  paCBG ='';
  paTemp ='';
  paWeight ='';
  paHeight ='';
  paAdjSa =0;
  notes ='';

  prnextlab = '';

  prHdAdj ='';
  prHdBsa ='';
  prHdBonet ='';
  prHdModifPerc ='';
  prHdWhay ='';

  prepMonth ='';
  prepYear ='';

  compCode ='1';
  userID ='sa';
  modifiedDate  ='2022-01-01';

}
